import { ResetPasswordForm } from "@/features/auth/components/reset-password-form";
import { createFileRoute } from "@tanstack/react-router";

interface ResetPasswordSearch {
  token: string;
}

export const Route = createFileRoute("/reset-password")({
  // Token přichází v query (?token=…) z e-mailového odkazu.
  validateSearch: (search: Record<string, unknown>): ResetPasswordSearch => ({
    token: typeof search.token === "string" ? search.token : "",
  }),
  component: ResetPasswordPage,
});

function ResetPasswordPage() {
  const { token } = Route.useSearch();
  return (
    <div
      data-testid="auth-reset-page"
      className="flex min-h-screen items-center justify-center bg-background p-4"
    >
      <ResetPasswordForm token={token} />
    </div>
  );
}
